import { ReactElement } from 'react';
import {
  CertificateContainer,
  HeaderLabel,
  HeadingRow,
  Label,
  Row,
  Title,
} from './styles';
import Lang from '@lang/en';
import HeadingField from './headingField';
import Field from './field';

export type CertificateI = {
  patientName: string;
  result: string;
  birthdate: string;
  passportNumber: string;
  arrivalDate: string;
  sampleType: string;
  timeSampled: string;
  timeAnalysed: string;
  testLabel: string;
};

const Certificate = ({ values }: { values: CertificateI }): ReactElement => {
  return (
    <CertificateContainer>
      <Title>
        <HeaderLabel>{Lang.healthCheckResultCertificateHeaderText}</HeaderLabel>
        <Label>
          {`${Lang.healthCheckResultCertificateSubHeadingTextStart}
          ${values.testLabel}
          ${Lang.healthCheckResultCertificateSubHeadingTextEnd}`}
        </Label>
      </Title>
      <HeadingRow>
        <HeadingField label="Patient name" value={values.patientName} />
        <HeadingField label="Result" value={values.result} />
      </HeadingRow>
      <Row>
        <Field label="Birthdate" value={values.birthdate} />
        <Field label="Passport Number" value={values.passportNumber} />
        <Field label="UK Arrival Date" value={values.arrivalDate} />
      </Row>
      <Row>
        <Field label="Sample Type" value={values.sampleType} />
        <Field label="Time Sampled" value={values.timeSampled} />
        <Field label="Time Analysed" value={values.timeAnalysed} />
      </Row>
    </CertificateContainer>
  );
};

export default Certificate;
